import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './assessor-reject-caption.styl'

export default class AssessorRejectCaption extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  }

  render() {
    const { onClick } = this.props

    return (
      <p className={styles.text}>
        <FormattedMessage
          id="label.or_dont_agree"
          defaultMessage="Or don’t agree? You can"
        />{' '}
        <a className="link" onClick={onClick}>
          <FormattedMessage
            id="label.reject_application"
            defaultMessage="reject this application"
          />
        </a>
      </p>
    )
  }
}
